import { defaultStore } from '@/library/firebase'

export const getAdminUsers = () => {
  return new Promise(resolve => {
    const result = []
    defaultStore
      .collection('users')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          result.push(Object.assign({ id: doc.id }, doc.data()))
        })
      })
    resolve(result)
  })
}
